import { render, staticRenderFns } from "./SuperUser.vue?vue&type=template&id=170ca99e"
import script from "./SuperUser.vue?vue&type=script&lang=js"
export * from "./SuperUser.vue?vue&type=script&lang=js"
import style0 from "./SuperUser.vue?vue&type=style&index=0&id=170ca99e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports